/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * OVERDUE — data minęła albo licznik doszedł do przebiegu terminu. DUE_SOON — do daty zostało najwyżej 30 dni albo do przebiegu najwyżej 1000 km, a wizyty nikt nie zaplanował. PLANNED_DATE_PASSED — zaplanowana wizyta minęła, a termin nie został odnowiony wpisem w dzienniku. PLANNED — wizyta zaplanowana. MISSING — brak daty i przebiegu. OK — termin aktualny. NOT_APPLICABLE — termin nie dotyczy auta. 
 */

export const CarDeadlineStateDto = {
    Ok: 'OK',
    DueSoon: 'DUE_SOON',
    Overdue: 'OVERDUE',
    Missing: 'MISSING',
    Planned: 'PLANNED',
    PlannedDatePassed: 'PLANNED_DATE_PASSED',
    NotApplicable: 'NOT_APPLICABLE',
} as const;

export type CarDeadlineStateDto = typeof CarDeadlineStateDto[keyof typeof CarDeadlineStateDto];



